export default "__VITE_ASSET__BVYWngUB__"